import { ArrowRight, Check } from "lucide-react";

const steps = [
  ["01", "Choose your part", "Search the master catalogue by category, name or SKU."],
  ["02", "Choose quantity", "Order one replacement or the exact quantity your bench needs."],
  ["03", "Confirm the price", "See direct CAD pricing before you commit to checkout."],
  ["04", "Add your address", "Stripe collects the shipping details securely."],
  ["05", "Check out", "Pay, receive acknowledgement and keep building."],
];

export default function ProcessSection() {
  return (
    <section className="process-section content-section" id="process" data-testid="order-process-section">
      <div className="section-heading"><div><p className="eyebrow">03 / Order protocol</p><h2>Five moves from<br /><em>need to bench.</em></h2></div><p className="section-side-note">No subscriptions. No distributor maze. The order desk stays simple whether you need one tube or a workshop quantity.</p></div>
      <div className="process-grid">{steps.map(([number, title, body], index) => <article className="process-card" key={number} data-testid={`order-process-step-${number}`}><span className="process-number">{number}</span><div><h3>{title}</h3><p>{body}</p></div>{index < steps.length - 1 ? <ArrowRight className="process-arrow" size={19} /> : <Check className="process-check" size={19} />}</article>)}</div>
    </section>
  );
}
